/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {RestResponse} from '../model';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {ApiHeaders} from './headers';

@Injectable()
export class LinkedReportProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {}

  getReports(page: number, query?: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/link/list` +
        (query ? '?query=' + encodeURIComponent(query) : ''),
        ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'LINKED_REPORT';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return null;
  }

  search(query?: string): Observable<RestResponse> {
    return this.getReports(1, query);
  }
}
